import { PROCESS_APPLICATION_ERROR_MESSAGES } from '#client/constants/messages';

import { APPLICATION_RECEIVED } from '../constants/application';

export const getEINBoxByErrorMessage = (errorMessage) => {
  // map error message with EIN content box
  switch (errorMessage) {
    case PROCESS_APPLICATION_ERROR_MESSAGES.AWAITING_FORMATION:
      return APPLICATION_RECEIVED.WAITING_BANKING_ORDER_PROCESSES;
    case PROCESS_APPLICATION_ERROR_MESSAGES.AWAITING_EIN_ORDER_COMPLETION:
      return APPLICATION_RECEIVED.BOUGHT_EIN_IN_PRE;
    case PROCESS_APPLICATION_ERROR_MESSAGES.AWAITING_EIN_ORDER_CREATION:
      return APPLICATION_RECEIVED.WILL_BUY_EIN;
    case PROCESS_APPLICATION_ERROR_MESSAGES.AWAITING_EIN:
      return APPLICATION_RECEIVED.WAITING_EIN;
    default:
      return null;
  }
};
